import type { SerializeJSOptions } from 'serialize-javascript';
import serializeJavascript from 'serialize-javascript';

export type Options = SerializeJSOptions | number | string;

/**
 * Ex:
 * serializeJS(dataObject, { isJSON: true });
 *
 * More configuration options:
 * https://github.com/yahoo/serialize-javascript#usage
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const serializeJS = (input: any, options?: Options) => serializeJavascript(input, options);
